export const GET_PLACEMENTS_SUCCESS = 'GET_PLACEMENTS_SUCCESS';
